module.exports = __webpack_public_path__ + "img/product_info.a0c91d8f.png";